import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import { ModifierValue } from 'src/models/Sidekick/SidekickThreads';
import ParentsPanel from './ParentsPanel';
import { selectCurrentModifier } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import { StyledContainer } from './ThreadParentsPanel';

type AnonModuleParentsPanelProps = {
  onBackToModule: () => void;
  setIsParentsLoading: (value: boolean) => void;
  parentItemId: string;
};

export const AnonModuleParentsPanel = forwardRef(
  ({ setIsParentsLoading, onBackToModule, parentItemId }: AnonModuleParentsPanelProps, ref) => {
    const modifier = useSelector(selectCurrentModifier) as ModifierValue;

    if (!modifier) {
      return null;
    }

    const parent = {
      id: `anon-${String(modifier.id)}`,
      name: `Add Rule${modifier.controlValues?.label ? `: ${modifier.controlValues?.label}` : ''}`,
    };
    const parents = [parent];

    const handleItemClick = () => {
      onBackToModule();
    };

    return (
      <StyledContainer ref={ref}>
        <ParentsPanel
          parentItemId={parentItemId}
          parents={parents}
          onItemClick={handleItemClick}
          setIsParentsLoading={setIsParentsLoading}
        />
      </StyledContainer>
    );
  }
);
